import Axios from 'axios';
import AuthProvider from "../provider/AuthProvider";

export default class DebugService {

    /**
     * 디버그 로그를 서버에 전송
     * @param {string} hzType - 측정 타입
     * @param {string} mode - 현재 모드
     * @param {string} stage - 현재 스테이지
     * @param {object} debugInfo - 디버그 정보 객체
     * @returns {Promise<boolean>}
     */
    static async sendDebugLog({ hzType, mode = null, stage = null, debugInfo }) {
        try {
            const profileID = AuthProvider.getProfileID();
            
            if (!profileID) {
                console.warn('Profile ID not found, skipping debug log');
                return false;
            }

            const result = await Axios.post('/api/log/debug', {
                profileID,
                hzType,
                mode,
                stage,
                debugInfo
            });

            if (result.data.success) {
                console.log(`Debug log sent successfully with ID: ${result.data.id}`);
                return { success: true, id: result.data.id };
            } else {
                console.error('Failed to send debug log:', result.data.message);
                return { success: false };
            }
        } catch (error) {
            console.error('Error sending debug log:', error);
            return { success: false };
        }
    }

    /**
     * 스테이지 문제 생성 시 디버그 정보 수집 및 전송
     * @param {object} params - 디버그 정보 수집에 필요한 매개변수
     */
    static async logStageProblems({ 
        hzType, 
        mode, 
        stage, 
        stageInfo, 
        randomProblem, 
        originalRandomProblem, 
        newProblem,
        renderView, 
        programView,
        isDoneShowDelayProblem,
        isDonePlayProblem 
    }) {
        try {
            const debugInfo = {
                stageInfo: {
                    type: stageInfo.type,
                    all: stageInfo.all,
                    selectorType: stageInfo.selectorType,
                    selectRatio: stageInfo.selectRatio,
                    min: stageInfo.min,
                    showType: stageInfo.showType,
                    direction: stageInfo.direction,
                    viewBox: stageInfo.viewBox,
                    levelText: stageInfo.levelText,
                    shortText: stageInfo.shortText,
                    randomDelay: stageInfo.randomDelay,
                    delay: stageInfo.delay,
                    background: stageInfo.background ? '[Background Image]' : null,
                    color: stageInfo.color,
                    showSub: stageInfo.showSub,
                    pairSub: stageInfo.pairSub,
                    minCorrect: stageInfo.minCorrect,
                    viewChar: stageInfo.viewChar
                },
                renderView: {
                    type: renderView.type,
                    cogBoxBackground: renderView.cogBoxBackground,
                    cogItemBackground: renderView.cogItemBackground,
                    dataLength: renderView.data ? renderView.data.length : 0,
                    metaLength: renderView.meta ? renderView.meta.length : 0
                },
                problemData: {
                    randomProblem: randomProblem.map(p => ({
                        randomIndex: p.randomIndex,
                        meta: p.meta,
                        isSelected: p.isSelected,
                        opacity: p.opacity,
                        renderViewChar: typeof p.renderViewChar === 'string' ? p.renderViewChar : '[Image Object]',
                        subView: p.subView ? (typeof p.subView === 'string' ? p.subView : '[SubImage Object]') : null,
                        originalIndex: p.originalIndex
                    })),
                    originalRandomProblem: originalRandomProblem ? originalRandomProblem.map(p => ({
                        randomIndex: p.randomIndex,
                        meta: p.meta,
                        renderViewChar: typeof p.renderViewChar === 'string' ? p.renderViewChar : '[Image Object]'
                    })) : [],
                    newProblem: newProblem ? newProblem.map(p => ({
                        randomIndex: p.randomIndex,
                        meta: p.meta,
                        isSelected: p.isSelected,
                        opacity: p.opacity,
                        renderViewChar: typeof p.renderViewChar === 'string' ? p.renderViewChar : '[Image Object]',
                        subView: p.subView ? (typeof p.subView === 'string' ? p.subView : '[SubImage Object]') : null,
                        originalIndex: p.originalIndex
                    })) : []
                },
                systemInfo: {
                    isDoneShowDelayProblem,
                    isDonePlayProblem,
                    programView,
                    totalProblems: randomProblem.length,
                    selectedProblems: randomProblem.filter(p => p.isSelected).length,
                    timestamp: new Date().toISOString()
                }
            };

            return await this.sendDebugLog({
                hzType,
                mode,
                stage,
                debugInfo
            });
        } catch (error) {
            console.error('Error logging stage problems:', error);
            return { success: false };
        }
    }
}